export const SAVE_CONFIG = "SAVE_CONFIG";
